export const environment = {
    baseUrl: 'https://apireportx.cloudsource.ge'
}
